import request from 'utils/request';
const api = {
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',
  GET_MENU_LIST: '/api/security/account/menu',
  USET_LIST: '/api/account/console/list',
  USER_BY_ROLE_LIST: '/api/account/role/account/list',
};

export function login(data) {
  return request({
    url: api.LOGIN,
    method: 'post',
    data,
  });
}
export function logout() {
  return request({
    url: api.LOGOUT,
    method: 'get',
  });
}
export function getMenuList() {
  return request({
    url: api.GET_MENU_LIST,
    method: 'get',
  });
}

export function getUserList() {
  return request({
    url: api.USET_LIST,
    method: 'get',
  });
}

export function getUserListByRole(roleName) {
  return request({
    url: `${api.USER_BY_ROLE_LIST}?roleName=${roleName}`,
    method: 'get',
  });
}
